import React from "react";

import NoticePreviewContainer from "components/record_details/NoticePreview";
import { ProHelperDataTypes, useProHelper } from "lib/providers/ProHelper";
import { useRecordViewer } from "lib/providers/RecordViewer";
import { EventData } from "lib/tracking";

export function useRestricedViewNotice(
  contextSource = "Row click",
  requiredDataType?: ProHelperDataTypes,
  trackingData?: EventData,
) {
  const { checkSubscription } = useProHelper();
  const { viewRecord: openRecord } = useRecordViewer({
    renderContent: (recordGuid) => (
      <NoticePreviewContainer guid={recordGuid} eventData={trackingData} />
    ),
  });

  const viewRecord = (recordGuid: string) => {
    if (
      requiredDataType &&
      !checkSubscription(requiredDataType, { "Context source": contextSource })
    ) {
      return;
    }

    openRecord(recordGuid, { "Context source": contextSource });
  };

  return { viewRecord };
}
